<template>
    <div class="bookallsender kanit">
      <div v-if="busy">
        <BlockUI class="line">
          <div class="new-loading">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </BlockUI>
      </div>
      <div
        v-else
        class="line-template-consign manage-sender kanit position-relative"
      >
        <div
          v-for="sender in senders"
          :key="sender.id"
          class="d-flex flex-column mt-2 pt-3 group-box py-3 px-3"
        >
          <div class="d-flex w-100">
            <div class="col-8">
              <div class="header-label">{{ sender.name }} | {{ sender.tel }}</div>
            </div>
            <div class="col-2">
              <div class="">
                <img
                  :src="icon.penceilEdit.url"
                  alt="pancil"
                  @click="activeEditSender(sender.id)"
                />
              </div>
            </div>
            <div class="col-2">
              <div class="">
                <img
                  :src="icon.trash.url"
                  alt="trash"
                  @click="deleteSender(sender.id)"
                />
              </div>
            </div>
          </div>
          <div class="d-flex w-100">
            <div class="col-12">
              <div class="detail-address text-line-muted">
                {{ sender.address }} {{  sender.district }} {{  sender.state }} {{  sender.province }} {{ sender.postcode }}
              </div>
              <div class="tags mt-2">
                <div
                  v-if="sender.active_address"
                  class="box-tag tags-address-active"
                >
                  ที่อยู่เริ่มต้น
                </div>
                <div
                  v-if="sender.tags === 'home'"
                  class="tags-non-active box-tag ml-2"
                >
                  บ้าน
                </div>
                <div
                  v-if="sender.tags === 'office'"
                  class="tags-non-active box-tag ml-2"
                >
                  ออฟฟิศ
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="line-fixed-circle">          
          <div class="circle-button">
            <b-button variant="line-primary" class="rounded-circle d-flex justify-content-center align-items-center" @click="addingSender">
              <img src="../../assets/images/line/plus.png" style="width: 35px;" alt="plus"/>
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="alertToast" class="border-toast">
        <span class="text-white">{{ messageToast }}</span>
      </div>
      <b-modal
        no-close-on-esc
        body-class="custom-padding"
        no-close-on-backdrop
        hide-footer
        v-model="deletePOPUP" 
        id="modal-center" 
        centered
        hide-header
    >
        <div class="custom-header-cancel">
            <div class="d-flex justify-content-between">
                <h2 class="font-size-cancel">ลบที่อยู่</h2>
                <span class="close cursor-pointer" @click="close()">&times;</span>
            </div>
        </div>
        <div class="custom-body-cancel">
            <div>
                <p class="description">
                    หากลบที่อยู่แล้วจะไม่สามารถเรียกคืนได้ ต้องการลบที่อยู่หรือไม่?
                </p>
                <hr class="line-setting">
                <div class="d-flex justify-content-between">
                    <div class="w-100 pr-1">
                        <b-button variant="outline-line-primary" block @click="close">
                            ปิดหน้าต่าง
                        </b-button>
                    </div>
                    <div class="w-100 pl-1">
                        <b-button variant="line-primary" block @click="activeDelete">
                            ลบที่อยู่
                        </b-button>
                    </div>
                </div>
            </div> 
        </div>  
      </b-modal>
    </div>
</template>
  
<script>
  import { formatLiff } from "@/constants/Lineliff";
  const context_line = JSON.parse(localStorage.getItem("context_line"));
  export default {
    metaInfo: {
      title: "สมุดที่อยู่",
    },
    data() {
      return {
        busy: true,
        messageToast: "",
        alertToast: false,
        deletePOPUP: false,
        tempIdDelete: null,
        icon: {
          penceilEdit: {
            url: require("../../assets/icon/penciledit.svg"),
          },
          trash: {
            url: require("../../assets/icon/delete.svg")
          },
        },
        selectedRadio: "",
        senders: [],
      };
    },
    methods: {
      close() {
        this.deletePOPUP = false
      },
      openToast(text) {
        this.messageToast = text
        this.alertToast = true
        setTimeout(() => {
            this.alertToast = false
        }, 1000)
      },
      deleteSender(orderid) {
        this.tempIdDelete = orderid
        this.deletePOPUP = true
      },
      activeDelete() {
        const headers = {
          headers: {
            Token: localStorage.getItem("access_token_customer")
          }
        }
        this.$http.delete(this.$API_URL + `/line/sender/${this.tempIdDelete}`, headers).then((res) => {
          const status = res.data.status
          if(!status) {
            this.$router.push('/location/timeout')
          }
        }).finally(async () => {
          await this.getSendersCustomer()
          this.deletePOPUP = false
        })
      },
      addingSender() {
        this.$router.push({ path: "/line/manage/sender", query: { action: "addFromBookSender" } });
      },
      activeEditSender(key) {
        this.$router.push({ path: "/line/manage/sender", query: { senderId: key, action: "editFromBookSender" } });
      },
      getSendersCustomer() {
        const headers = {
          headers: {
            Token: localStorage.getItem("access_token_customer"),
          },
        };
        this.$http
          .post(this.$API_URL + "/line/get/senders", {}, headers)
          .then((res) => {
            const status = res.data.status;
            if (!status) {
              return this.$router.push("/location/timeout");
            }
            this.senders = res.data.data;
            this.selectedRadio = this.senders[0].id;
            this.busy = false;
          });
      },
      isHasRegister() {
        const headers = {
          headers: {
            Token: localStorage.getItem("access_token_customer"),
          }
        }
        this.$http.get(this.$API_URL + "/line/is/register/shop", headers).then((res) => {
          const status = res.data.status
          if(!status) {
            this.$router.push("/line/action/register")
          }
        })
      }
    },
    mounted() {
      this.$liff.init({
        liffId: context_line.liffId,
      });
      this.isHasRegister()
      this.getSendersCustomer();
    },
  };
</script>
  